const store = require.context("./Store", true);
store.keys().forEach(key => store(key));
if (module.hot) {
    module.hot.accept(store.id, () => onHotWidgetReplace(require.context("./Store", true)));
}

const services = require.context("./Services", true);
if (module.hot) {
    module.hot.accept(services.id, () => onHotWidgetReplace(require.context("./Services", true)));
}

const widgets = require.context("./Widgets", true, /\.tsx$/);
const onHotWidgetReplace = addWidgetsFromContext(widgets);
// ensure HMR works for custom widgets
if (module.hot) {
    module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context("./Widgets", true, /\.tsx$/)));
}

// Enable hot module reloading for custom widgets.
// if (module.hot) {
//     module.hot.accept(widgets.id, () => onHotWidgetReplace(require.context('./Components/Widgets', true, /\.tsx$/)));
// }

// Load all handlers so they are included in the bundle.
// Recursively get all handler modifications
const handlers = require.context("./Handlers", true);
// Load the handler modifications.
handlers.keys().forEach(key => handlers(key));
if (module.hot) {
    module.hot.accept(handlers.id, () => onHotWidgetReplace(require.context("./Handlers", true)));
}

// Load all the extensions to the base widgets. This includes style extensions.
const widgetExtensions = require.context("./WidgetExtensions", true);
widgetExtensions.keys().forEach(key => widgetExtensions(key));

// load all pages. Without this they won't be included in the bundle
const pages = require.context("./Pages", true, /\.tsx$/);
const onHotPageReplace = addPagesFromContext(pages);
if (module.hot) {
    module.hot.accept(pages.id, () => onHotPageReplace(require.context("./Pages", true, /\.tsx$/)));
}

import { addPagesFromContext, addWidgetsFromContext } from "@insite/client-framework/Components/ContentItemStore";
import { setPostStyleGuideTheme, setPreStyleGuideTheme } from "@insite/client-framework/ThemeConfiguration";
import { css } from "styled-components";

setPreStyleGuideTheme({
    colors: {
        primary: {
            main: "#8D1000",
        },
        secondary: {
            main: "#EE3124",
        },
    },
    globalStyle: {
        css: css`
            [data-test-selector="productListCardContainerList"] {
                padding-left: 25px;
                padding-right: 25px;
            }
            input[type="number"]::-webkit-outer-spin-button,
            input[type="number"]::-webkit-inner-spin-button {
                opacity: 1;
            }

            button:focus {
                outline: none !important;
                outline-width: 0 !important;
            }

            a:focus {
                outline: none !important;
                outline-width: 0 !important;
            }
        `,
    },
    typography: {
        fontFamilyImportUrl: "https://fonts.googleapis.com/css?family=Roboto:300,400,600,700,800&display=swap",
        body: {
            size: "15px",
            weight: 400,
            fontFamily: "'Roboto', 'Open Sans', 'Lato', sans-serif",
        },
        p: {
            size: "15px",
            weight: 400,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h1: {
            size: "40px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h2: {
            size: "32px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h3: {
            size: "28px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h4: {
            size: "24px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h5: {
            size: "20px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        h6: {
            size: "16px",
            weight: 700,
            css: css`
                margin-bottom: 1rem;
                display: block;
            `,
        },
        headerPrimary: {
            forwardAs: "p",
            size: "24px",
            fontFamily: "'Roboto', 'Open Sans SemiBold', 'Lato', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
        headerSecondary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', 'Open Sans SemiBold', 'Lato', sans-serif",
            transform: "uppercase",
            weight: 800,
        },
        headerTertiary: {
            forwardAs: "p",
            size: "15px",
            fontFamily: "'Roboto', 'Open Sans SemiBold', 'Lato', sans-serif",
            color: "text.main",
            transform: "uppercase",
        },
        legend: {
            forwardAs: "span",
            size: "10px",
            color: "text.accent",
            transform: "uppercase",
            weight: 600,
        },
    },
});

setPostStyleGuideTheme({
    breakpoints: {
        keys: ["xs", "sm", "md", "lg", "xl"],
        values: [0, 576, 768, 1195, 1441],
        maxWidths: [540, 540, 920, 1400, 1400],
    },
});
